/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TenantEntity } from './TenantEntity';
import {
    TenantEntityFromJSON,
    TenantEntityFromJSONTyped,
    TenantEntityToJSON,
    TenantEntityToJSONTyped,
} from './TenantEntity';
import type { AuthConfigEntity } from './AuthConfigEntity';
import {
    AuthConfigEntityFromJSON,
    AuthConfigEntityFromJSONTyped,
    AuthConfigEntityToJSON,
    AuthConfigEntityToJSONTyped,
} from './AuthConfigEntity';
import type { SignInMethodEntity } from './SignInMethodEntity';
import {
    SignInMethodEntityFromJSON,
    SignInMethodEntityFromJSONTyped,
    SignInMethodEntityToJSON,
    SignInMethodEntityToJSONTyped,
} from './SignInMethodEntity';

/**
 * 
 * @export
 * @interface TenantWithSignInMethodEntity
 */
export interface TenantWithSignInMethodEntity {
    /**
     * テナント
     * @type {TenantEntity}
     * @memberof TenantWithSignInMethodEntity
     */
    tenant: TenantEntity;
    /**
     * 
     * @type {AuthConfigEntity}
     * @memberof TenantWithSignInMethodEntity
     */
    tenantAuthConfig: AuthConfigEntity;
    /**
     * ユーザーがテナントで許容されるサインイン方法
     * @type {Array<SignInMethodEntity>}
     * @memberof TenantWithSignInMethodEntity
     */
    userSignInMethods: Array<SignInMethodEntity>;
}

/**
 * Check if a given object implements the TenantWithSignInMethodEntity interface.
 */
export function instanceOfTenantWithSignInMethodEntity(value: object): value is TenantWithSignInMethodEntity {
    if (!('tenant' in value) || value['tenant'] === undefined) return false;
    if (!('tenantAuthConfig' in value) || value['tenantAuthConfig'] === undefined) return false;
    if (!('userSignInMethods' in value) || value['userSignInMethods'] === undefined) return false;
    return true;
}

export function TenantWithSignInMethodEntityFromJSON(json: any): TenantWithSignInMethodEntity {
    return TenantWithSignInMethodEntityFromJSONTyped(json, false);
}

export function TenantWithSignInMethodEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantWithSignInMethodEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'tenant': TenantEntityFromJSON(json['tenant']),
        'tenantAuthConfig': AuthConfigEntityFromJSON(json['tenantAuthConfig']),
        'userSignInMethods': ((json['userSignInMethods'] as Array<any>).map(SignInMethodEntityFromJSON)),
    };
}

export function TenantWithSignInMethodEntityToJSON(json: any): TenantWithSignInMethodEntity {
    return TenantWithSignInMethodEntityToJSONTyped(json, false);
}

export function TenantWithSignInMethodEntityToJSONTyped(value?: TenantWithSignInMethodEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenant': TenantEntityToJSON(value['tenant']),
        'tenantAuthConfig': AuthConfigEntityToJSON(value['tenantAuthConfig']),
        'userSignInMethods': ((value['userSignInMethods'] as Array<any>).map(SignInMethodEntityToJSON)),
    };
}

